import React from 'react';
import { Translate } from 'react-jhipster';

import MenuItem from 'app/shared/layout/menus/menu-item';

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}
      <MenuItem icon="book" to="/erpaxa">
        <Translate contentKey="global.menu.entities.erpaxa" />
      </MenuItem>
      <MenuItem icon="tasks" to="/service-record">
        <Translate contentKey="global.menu.entities.serviceRecord" />
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
